const truncateMessage = (message, ignoreTruncateMessage) => {
  if (ignoreTruncateMessage) {
    return message;
  }

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  if (screenWidth <= 620) {
    if (message.length <= 75) {
      return message;
    } else {
      return `${message.slice(0, 75)}...`;
    }
  } else {
    return message;
  }
};

export default truncateMessage;
